import en from './en.json';
import no from './no.json';
import uk from './uk.json';
import ru from './ru.json';
import nb from './nb.json';

const translationData = { en, no, uk, ru, nb };

export default translationData;
